import React, { useContext, useEffect, useMemo } from 'react';
import { Amount, useFormsContext } from '@ally/forms';
import { getBalance } from '@ally/transfer-account-utils';
import { withProps } from '@ally/validator';
import validator from './validator';
import { useComputedValues } from '../../useComputedValues';
import { TransferSpeedsContext } from '../../useTransferSpeeds';
import { ClosingFee } from '../../constants';
var AmountInput = function (_a) {
    var _b = _a.disableNewCustomerLimit, disableNewCustomerLimit = _b === void 0 ? false : _b, _c = _a.isNewCustomer, isNewCustomer = _c === void 0 ? false : _c, newCustomerLimit = _a.newCustomerLimit;
    var _d = useFormsContext(), values = _d.values, setFieldValue = _d.setFieldValue;
    var _e = useComputedValues(), fromAccount = _e.fromAccount, toAccount = _e.toAccount, disableForm = _e.disableForm;
    var withdrawalDate = useContext(TransferSpeedsContext).withdrawalDate;
    var isDistributionFull = values.distributionAmountType === 'full';
    var validate = useMemo(function () {
        return withProps(validator, {
            disableNewCustomerLimit: disableNewCustomerLimit,
            fromAccount: fromAccount,
            isNewCustomer: isNewCustomer,
            newCustomerLimit: newCustomerLimit,
            toAccount: toAccount,
            values: values,
            withdrawalDate: withdrawalDate,
        });
    }, [
        disableNewCustomerLimit,
        fromAccount,
        isNewCustomer,
        newCustomerLimit,
        toAccount,
        values,
        withdrawalDate,
    ]);
    useEffect(function () {
        if (fromAccount && values.distributionAmountType) {
            /**
             * Show amount minus the closing fee when full amount option is selected
             */
            if (isDistributionFull) {
                var balanceAfterClosingFees = getBalance(fromAccount) - ClosingFee;
                setFieldValue('amount', balanceAfterClosingFees);
            }
            else {
                setFieldValue('amount', null);
            }
        }
    }, [values.distributionAmountType]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Amount, { name: "amount", validate: validate, "aria-required": true, disabled: disableForm || isDistributionFull })));
};
export default AmountInput;
//# sourceMappingURL=Input.js.map